import { render, staticRenderFns } from "./myLoveRecord.vue?vue&type=template&id=fac9126a&scoped=true&"
import script from "./myLoveRecord.vue?vue&type=script&lang=js&"
export * from "./myLoveRecord.vue?vue&type=script&lang=js&"
import style0 from "./myLoveRecord.vue?vue&type=style&index=0&id=fac9126a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac9126a",
  null
  
)

export default component.exports